<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/label/operation/log/page" getKey="rows"
                   :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('biaoqqiantiaoma')">
            <el-input v-model="yt.conditions.labelBarcodeNumber"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('caozuoleixing')">
            <yi_dictionary_select  clearable :type="'LABEL_OPERATION_TYPE'" :ids.sync="yt.conditions.operationType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('caozuoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart"
                           :end.sync="yt.conditions.createTimeEnd"
                           :placeholder="$t('xuanzeriqiheshijian')"></yi_time_input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
                   @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>


  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_label_management_label_operation_log_list',
  components: {},
  data() {
    return {
      rePrintObj: {},
      isShowPrintDialog: false,
      columns: [
        {
          label: 'biaoqqiantiaoma',
          prop: 'labelBarcodeNumber',
          width: 150
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 150
        },
        {
          label: 'baozhuangshuliang',
          prop: 'packageNumber',
          width: 150
        },
        {
          label: 'caozuoleixing',
          prop: 'operationType',
          type: 'dictionary',
          key: 'LABEL_OPERATION_TYPE',
          width: 150
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 150
        },
        {
          label: 'yibaogongbuliangpinshu',
          prop: 'finishBadQuantity',
          width: 150
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 150
        },
        {
          label: 'caozuoshijian',
          prop: 'createTime',
          type: 'time',
          width: 230,
        },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname',
          width: 130,
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  computed: {},
  methods: {}


};
</script>
